module.exports = __webpack_public_path__ + "img/filtericon.183984be.svg";